export default __webpack_public_path__ + "static/media/einstein.efdc1703.jpg";